import { useEffect, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { OPERATIONAL_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { getObjectURLFromMediaURLWithCaching } from '@atlassian/help-center-common-util/media-services';

export const useCachedUrl = function (inputUrl: string | null | undefined) {
    const [cachedBannerUrl, setCachedBannerUrl] = useState<string | null>();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    useEffect(() => {
        if (!!inputUrl && inputUrl.startsWith('blob:')) {
            setCachedBannerUrl(inputUrl);
        } else if (!!inputUrl) {
            getObjectURLFromMediaURLWithCaching(inputUrl)
                .then((url) => setCachedBannerUrl(url))
                .catch((errorMessage: string) => {
                    createAnalyticsEvent({
                        analyticsType: OPERATIONAL_EVENT_TYPE,
                        action: 'failed',
                        actionSubject: 'useCachedUrl',
                        attributes: {
                            error: errorMessage,
                        },
                    }).fire();
                });
        } else {
            setCachedBannerUrl(null);
        }
    }, [createAnalyticsEvent, inputUrl, setCachedBannerUrl]);

    return cachedBannerUrl;
};
